// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"36ca9826","703":"b94b104c","787":"afada19f"}[chunkId] + ".chunk.js";
};